import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsCountries from "../generic-nav-bar/NavbarIconsCountries";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { countryStartRegister } from "../../app/actions/catalogCountryActions";
import { schemaValidateCountriesList } from "../../app/data/schemaValidateCountriesList";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import ViewLabel from "../generic-component/ViewLabel";
import NewCatalogLocationGenericForAdmin from "../generic-component/NewCatalogLocationGenericForAdmin";

const ID_FORM = "admin-country";
const OPERATION = "register";

const NewCountries = () => {
  debugLogPages(':: NewCountries'); 

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { catalogCountry } = useSelector((state) => state.catalogCountry);

  const { catalogRegions } = useSelector((state) => state.catalogRegion);

  const { t } = useTranslation();

  const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocationForAdmin } = useFormValidationsGeneric(
      () => countryCallback(),
      catalogCountry,
      schemaValidateCountriesList
    );

  useEffect(() => {

    if (values) {
      handleChange(getObjectById(values.region_id, catalogRegions), "region_id");

    }

  }, [catalogRegions])

  const getObjectById = (id, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.id === id);
    return elementFound;
  };

  const getMethodData = (currentData) => {
    let comboData = [];
    let level = 0;

    if (currentData === "region_id") {
      comboData = catalogRegions;
      level = 1;
    }

    return { comboData, level };
  };

  const countryCallback = () => {
    debugLogPages(':: NewCountries, countryCallback, values', {values}); 

    let valuesSubmit = { ...values };
    //valuesSubmit.region_id = valuesSubmit.region_id.id;

    valuesSubmit.deleted = false;

    debugLogPages(':: NewCountries, countryCallback, valuesSubmit', {valuesSubmit}); 
    dispatch(countryStartRegister(valuesSubmit, navigate));

  };

  debugLogPages(':: NewCountries', {errors}); 
  debugLogPages(':: NewCountries', {values}); 

  return (
    <div>
      <NavbarIconsCountries page={"newCountries"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

            {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateCountriesList && schemaValidateCountriesList.length > 0 && (
                  schemaValidateCountriesList.map((techSecondary, index) => {

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;
                    const { comboData } = getMethodData(techSecondary.field);

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGenericForAdmin") {
                      return (
                        <NewCatalogLocationGenericForAdmin
                          key={techSecondary.id}
                          handleChange={handleChangeLocationForAdmin}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewCountries;
